import { render } from "./InternCoretimeApprovalDataTable.vue?vue&type=template&id=228242e2"
import script from "./InternCoretimeApprovalDataTable.vue?vue&type=script&lang=js"
export * from "./InternCoretimeApprovalDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__